/**
 * activeConnectionLookup — thin shim over `getConnectionById` exposing the
 * subset of connection metadata `openInDependencyViewer` needs to populate
 * the new tab's `connectionInfo`. Kept on its own so tests can stub the
 * lookup without pulling the connection store wiring.
 *
 * Slice H3.
 */
import { getConnectionById } from '../../../connections/utils/connectionLookup';
import { safeConnectionAlias, safeConnectionServer } from '../../../../types/safeConnectionDisplay';

export interface ActiveConnectionInfo {
  readonly connectionName: string;
  readonly serverHost: string;
}

export function getActiveConnectionForId(
  connectionId: string,
): ActiveConnectionInfo | null {
  const { activeConnection, connection } = getConnectionById(connectionId);
  if (!activeConnection || !connection) return null;
  return {
    connectionName: safeConnectionAlias(connection, 'Unnamed Connection'),
    serverHost: safeConnectionServer(activeConnection.connection),
  };
}
